<template>
  <b-card
    no-body
    :class="{'open': visible}"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-header
      :class="[
        !visible && 'collapsed',
        classHeaderCollapse
      ]"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible)"
    >
      <slot name="header">
        <div>
          <feather-icon
              v-if="icon"
              :icon="icon"
              class="mr-50 text-white"
          />
          <span class="lead collapse-title">{{ title }}</span>
          <b-badge
              v-if="countFields > 0"
              variant="danger" class="ml-1">
            {{countFields}}
          </b-badge>
        </div>
      </slot>
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <b-card-body>
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCollapse,
} from 'bootstrap-vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
      require: false,
    },
    idCollapse: {
      type: String,
      default: null,
      require: false,
    },
    classHeaderCollapse: {
      type: String,
      default: null,
      require: false,
    },
    countFields: {
      type: Number,
      default: 0,
      require: false,
    },
  },
  data() {
    return {
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
    };
  },
  computed: {
    accordion() {
      return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null;
    },
  },
  created() {
    this.collapseItemID = !this.idCollapse ? uuidv4() : this.idCollapse;
    this.visible = this.isVisible;
  },
  methods: {
    updateVisible(val = true) {
      this.visible = val;
      this.$emit('visible', val);
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true);
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false);
    },
  },
};
</script>
